import * as Tabs from '@radix-ui/react-tabs'
import { ReactNode } from 'react'

interface TabItem {
    icon?: ReactNode
    label: ReactNode
    value: string
    content: ReactNode
}

interface ContactTabsProps {
    tabs: TabItem[]
    defaultValue?: string
    handleClick?: (value: string) => void
    componentOptions?: ReactNode
}

const DefaultTabs = ({ tabs, defaultValue, handleClick, componentOptions }: ContactTabsProps) => {
    return (
        <Tabs.Root
            defaultValue={defaultValue ?? (tabs[0] && tabs[0].value)}
            className='text-gray-800 dark:text-white/90 space-y-2'
        >
            <Tabs.List className='grid grid-cols-1 md:flex md:flex-row justify-center md:justify-start md:items-center gap-1 md:gap-2'>
                {tabs.map(tab => (
                    <Tabs.Trigger
                        key={tab.value}
                        value={tab.value}
                        onClick={() => handleClick && handleClick(tab.value)}
                        className='px-4 py-2 rounded-xl border-[2px] data-[state=inactive]:border-transparent data-[state=active]:border-brand-500 data-[state=active]:text-brand-500 cursor-pointer bg-brand-50 dark:bg-brand-500/[0.12] text-sm flex items-center justify-center gap-1 whitespace-nowrap'
                    >
                        {tab.icon && tab.icon}
                        {tab.label}
                    </Tabs.Trigger>
                ))}
                {/* Dropdown com as opções */}
                {componentOptions && componentOptions}
            </Tabs.List>
            {tabs.map(tab => (
                <Tabs.Content key={tab.value} value={tab.value}>
                    {tab.content}
                </Tabs.Content>
            ))}
        </Tabs.Root>
    )
}

export default DefaultTabs
